
























































import {
    translate,
    availableLanguages,
} from "@/services/translate.service";
import LanguageSelector from "@/components/LanguageSelector.vue";
import Vue from 'vue'
import { EventBus } from "@/event-bus";

export default {
    props: ['title', 'item', 'field'],
    data() {
        return {
            selectedLanguage: { name: '', locale: '' },
            testList: ['A', 'B', 'C'],
            languages: [],
            renderItems: true,
            translate_message: [],
            sourceLanguage: { name: 'German', locale: 'de' }, // JZ TODO: Make selectable
        };
    },
    methods: {
        async translate(targetLanguage: any) {
            console.log('translate', targetLanguage);
            this.item[this.getFieldName(targetLanguage)] = await translate(this.item[this.getFieldName(this.sourceLanguage)], this.sourceLanguage.locale, targetLanguage.locale);
            this.forceRender();
        },
        getFlagURL(locale: string) {
            return `/assets/img/flags/${locale}.svg`;
            // means u have neither name nor site  
        },
        getFieldName(language: any = null) {
            let fieldName = this.field;
            if (!language) {
                language = this.selectedLanguage;
            }
            if (language.locale != 'de') {
                fieldName += '_' + language.locale;
            }
            return fieldName;
        },
        onLanguageChanged(language: any) {
            console.log('onLanguageChanged', language);
            this.selectedLanguage = language;
        },
        initSelectedLanguage() {
            if (this.$store.state.lang) {
                this.languages.forEach(l => {
                    if (l.locale == this.$store.state.lang) {
                        this.selectedLanguage = l;
                    }
                });
            }
        },
        async forceRender() {
            // Workaround: Without this, the items are changed internally but not shown on the UI
            this.renderItems = false;
            await Vue.nextTick();
            this.renderItems = true;
        },
 
    },
    mounted() {
        const languages = availableLanguages();

        console.log('availableLanguages', languages);
        this.languages.push({ name: this.$i18n.t('SHOW_ALL'), locale: null },)
        languages.forEach(l => {
            this.languages.push({ name: this.$i18n.t(l), locale: l },)
        });
        this.selectedLanguage = this.languages[1];
        this.initSelectedLanguage();

    },
   
    components: {
        LanguageSelector
    },
    computed: {
        currentLocale() {
            return this.$store.state.lang;
        }
    },
    watch: {
        currentLocale: {
            handler: function (newValue) {
                console.log('locale changed', newValue);
                this.initSelectedLanguage();
            },
            deep: true
        }
    },
}
